import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { map } from 'rxjs/operators';
import { Globals } from '@app/globals';
import { GlobalsEdit } from '@app/globals';
import { BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { AppService } from '@app/app.service';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
 //export class AdminService extends Socket {
export class AdminService {

   ID_RC = environment.ID_RC;
   NEMO_RC = environment.NEMO_RC;
   NEMO_RC_PORTERO1 = environment.NEMO_RC_PORTERO1;
   NEMO_RC_PORTERO2 = environment.NEMO_RC_PORTERO2;

   private _estado_rc1 = new BehaviorSubject(0);
   private _fondo_rc1 = new BehaviorSubject(0);
   private _estado_rc0 = new BehaviorSubject(0);
   private _fondo_rc0 = new BehaviorSubject(0);
   private _estado_rcc = new BehaviorSubject(0);
   private _fondo_rcc = new BehaviorSubject(0);
   private _estado_rcd = new BehaviorSubject(0);
   private _fondo_rcd = new BehaviorSubject(0);
   private _estado_rcsot = new BehaviorSubject(0);
   private _fondo_rcsot = new BehaviorSubject(0);
   private _estado_rcser = new BehaviorSubject(0);
   private _fondo_rcser = new BehaviorSubject(0);

   estado_rc1 = this._estado_rc1.asObservable();
   fondo_rc1 = this._fondo_rc1.asObservable();
   estado_rc0 = this._estado_rc0.asObservable();
   fondo_rc0 = this._fondo_rc0.asObservable();
   estado_rcc = this._estado_rcc.asObservable();
   fondo_rcc = this._fondo_rcc.asObservable();
   estado_rcd = this._estado_rcd.asObservable();
   fondo_rcd = this._fondo_rcd.asObservable();
   estado_rcsot = this._estado_rcsot.asObservable();
   fondo_rcsot = this._fondo_rcsot.asObservable();
   estado_rcser = this._estado_rcser.asObservable();
   fondo_rcser = this._fondo_rcser.asObservable();

   private API = Globals.BASE_API_URL;

   constructor(
      private socket: Socket,
      private http: HttpClient,
      private servicioApp: AppService ) {
      // Mensaje para informar que ha arrancado
      this.socket.emit('message', this.NEMO_RC + ' up');

      // Escucha eventos de comandos
      socket.on('command', (data) => {
         console.log('command -> ', data);

         switch ( data ) {
            case 'ping':
               this.socket.emit('message', this.NEMO_RC + ' online');
               break;
         }
      });

      socket.on('response', (data) => {
         console.log('response -> ', data);

         switch ( data.tipo ) {
            case 'status':
               if ( data.rc === 'rc-recepcion.' + this.ID_RC ) {
                  this.setEstado_rc0( data.valor );
               } else if ( data.rc === 'rc-plantaprimera.' + this.ID_RC ) {
                  this.setEstado_rc1( data.valor );
               } else if ( data.rc === 'rc-sotano.' + this.ID_RC ) {
                  this.setEstado_rcsot( data.valor );
               } else if ( data.rc === 'rc-cocina.' + this.ID_RC ) {
                  this.setEstado_rcc( data.valor );
               } else if ( data.rc === 'rc-despacho.' + this.ID_RC ) {
                  this.setEstado_rcd( data.valor );
               } else if ( data.rc === 'rc-servicio.' + this.ID_RC ) {
                  this.setEstado_rcser( data.valor );
               }
               break;
            case 'idfondo':
               if ( data.rc === 'rc-recepcion.' + this.ID_RC ) {
                  this.selecionarFondo(0, data.valor);
               } else if ( data.rc === 'rc-plantaprimera.' + this.ID_RC ) {
                  this.selecionarFondo(1, data.valor);
               } else if ( data.rc === 'rc-sotano.' + this.ID_RC ) {
                  this.selecionarFondo(2, data.valor);
               } else if ( data.rc === 'rc-cocina.' + this.ID_RC ) {
                  this.selecionarFondo(3, data.valor);
               } else if ( data.rc === 'rc-despacho.' + this.ID_RC ) {
                  this.selecionarFondo(4, data.valor);
               } else if ( data.rc === 'rc-servicio.' + this.ID_RC ) {
                  this.selecionarFondo(5, data.valor);
               }
               break;
         }
      });

      // Escucha eventos de peticiones
      socket.on('request', (data) => {
         console.log('request -> ', data);

         if ( data.rc === 'BROADCAST' ) {
            switch ( data.tipo ) {
               case 'setEstado':
                  this.setEstado_rc0( data.valor );
                  this.setEstado_rc1( data.valor );
                  this.setEstado_rcsot( data.valor );
                  this.setEstado_rcc( data.valor );
                  this.setEstado_rcd( data.valor );
                  this.setEstado_rcser( data.valor );

                  break;
            }
         }
      });

      // Escucha eventos de timbre
      socket.on('timbre', (data) => {
         console.log('timbre -> ', data);

         switch( data.status ) {
            case 'sonando':
               if ( data.rc === this.NEMO_RC_PORTERO1 || data.rc === this.NEMO_RC_PORTERO2 ) {
                  this.servicioApp.setTimbre({sonando: true, rc: data.rc});
               }
               break;
            case 'contestado':
               if ( data.rc.split(".")[1] !== undefined && data.rc.split(".")[1] === this.ID_RC ) {
                  this.servicioApp.setTimbre({sonando: false, rc: data.rc});
               }
               break;
         }
      });
   }
   selecionarFondo(rc: number,codigofondo: number)  {
      return this.http.post<any>(this.API + '/Fondos/Fondos/leerFondo', {
         codigofondo: codigofondo,
         key: GlobalsEdit.API_KEY
      }, { withCredentials: false })
      .pipe(map(data => {
         switch( rc ) {
            case 0: this.setFondo_rc0(data.valor); break;
            case 1: this.setFondo_rc1(data.valor); break;
            case 2: this.setFondo_rcsot(data.valor); break;
            case 3: this.setFondo_rcc(data.valor); break;
            case 4: this.setFondo_rcd(data.valor); break;
            case 5: this.setFondo_rcser(data.valor); break;
         }
      })).subscribe();
   }
   getEstado(idrc){
      this.socket.emit('request', { tipo: 'status', rc: idrc });
   }
   getFondo(idrc){
      this.socket.emit('request', { tipo: 'idfondo', rc: idrc } );
   }

   setEstado_rc1(estado){
      this._estado_rc1.next(estado);
   }
   setFondo_rc1(idfondo){
      this._fondo_rc1.next(idfondo);
   }
   setEstado_rc0(estado){
      this._estado_rc0.next(estado);
   }
   setFondo_rc0(idfondo){
      this._fondo_rc0.next(idfondo);
   }
   setEstado_rcc(estado){
      this._estado_rcc.next(estado);
   }
   setFondo_rcc(idfondo){
      this._fondo_rcc.next(idfondo);
   }
   setEstado_rcd(estado){
      this._estado_rcd.next(estado);
   }
   setFondo_rcd(idfondo){
      this._fondo_rcd.next(idfondo);
   }
   setEstado_rcsot(estado){
      this._estado_rcsot.next(estado);
   }
   setFondo_rcsot(idfondo){
      this._fondo_rcsot.next(idfondo);
   }
   setEstado_rcser(estado){
      this._estado_rcser.next(estado);
   }
   setFondo_rcser(idfondo){
      this._fondo_rcser.next(idfondo);
   }

   cambiarEstadoRc(idrc, estado) {
      let nemo;

      switch ( idrc ) {
         case 0:
            nemo = 'rc-recepcion.' + this.ID_RC;
            this.setEstado_rc0(estado);
            break;
         case 1:
            nemo = 'rc-plantaprimera.' + this.ID_RC;
            this.setEstado_rc1(estado);
            break;
         case 2:
            nemo = 'rc-sotano.' + this.ID_RC;
            this.setEstado_rcsot(estado);
            break;
         case 3:
            nemo = 'rc-cocina.' + this.ID_RC;
            this.setEstado_rcc(estado);
            break;
         case 4:
            nemo = 'rc-despacho.' + this.ID_RC;
            this.setEstado_rcd(estado);
            break;
         case 5:
            nemo = 'rc-servicio.' + this.ID_RC;
            this.setEstado_rcser(estado);
            break;
      }

      this.socket.emit('request', { tipo: 'setEstado', rc: nemo, valor: estado });
   }
   cambiarFondoRc(idrc, codigofondo) {
      let nemo;

      switch ( idrc ) {
         case 0: nemo = 'rc-recepcion.' + this.ID_RC; break;
         case 1: nemo = 'rc-plantaprimera.' + this.ID_RC; break;
         case 2: nemo = 'rc-sotano.' + this.ID_RC; break;
         case 3: nemo = 'rc-cocina.' + this.ID_RC; break;
         case 4: nemo = 'rc-despacho.' + this.ID_RC; break;
         case 5: nemo = 'rc-servicio.' + this.ID_RC; break;
      }

      this.socket.emit('request', { tipo: 'setFondo', rc: nemo, valor: codigofondo });
   }

   emitirEventoTimbre(estado: string) {
      this.socket.emit('timbre', { status: estado, rc: this.NEMO_RC} );
   }

   emitirCambioEstadoGlobal( estado ) {
      this.socket.emit('request', { tipo: 'setEstado', rc: 'BROADCAST', valor: estado });
   }
}
